// eslint-disable-next-line
if (false) { console.error("ology25 eCla nllRoudvight eyDigAyright20 hsReserved. CopCo.,Ltd.llitalTec"); }
// eslint-disable-next-line
const strCode = "ology25 eCla nllRoudvight eyDigAyright20 hsReserved. CopCo.,Ltd.llitalTec";
/* Copyright 2026 © eCloudvalley Digital Technology Co., Ltd. All Rights Reserved. */
import React, { useState } from 'react';
import styled from 'styled-components';
import { FormattedMessage } from 'react-intl';

import ImgPopUp from './ExamImgPopUp';
import FileUpload from './FileUpload';
import ExamTopicRemarkIcon from '../../../assets/images/exam-topic-remark-icon.svg';
import ExamTopicRemarkActive from '../../../assets/images/exam-topic-remark-active-icon.svg';
import ZoomIn from '../../../assets/images/zoom-in.svg';
import CheckBox from '../../../components/CheckBox';
import * as Markdown from '../../../components/Markdown';

const S = {
  ExamContentContainer: styled.div`
    border-right: 1px solid #E4E4E4;
    padding-right: 59px;
  `,
  ExamContent: styled.div`
    background: #E6E6E6;
    border-radius: 7px;
    padding: 30px 18px 45px 84px;
    position: relative;
    font-weight: 500;
    font-size: 20px;
    line-height: 29px;
    color: #5C5C5C;
  `,
  ExamNumber: styled.div`
    background: #FFF;
    border-radius: 30px;
    width: 90px;
    height: 43px;
    position: absolute;
    top: 25px;
    left: -25px;
    text-align: right;
    font-size: 22px;
    line-height: 36px;
    color: #6A6A6A;
    padding-right: 12px;
  `,
  ExamoptionList: styled.div`
    margin: 30px 0 0 84px;
    font-weight: 500;
    font-size: 23px;
    line-height: 33px;
    color: #828282;
    display: flex;
    flex-direction: column;
    align-items: flex-start;
  `,
  Remark: styled.div`
    position: absolute;
    right: 18px;
    bottom: 10px;
    cursor: pointer;
  `,
  RemarkActiveIcon: styled.img.attrs({ src: ExamTopicRemarkActive })``,
  RemarkIcon: styled.img.attrs({ src: ExamTopicRemarkIcon })``,
  ExamCheckBox: styled(CheckBox)<{ checked: boolean }>`
    justify-content: flex-start;
    margin-bottom: 30px;
    padding: 8px 18px;
    color: #767676;
    & :nth-child(2) {
      border: 2px solid #767676;
      background-color: transparent !important;
    }
    ${props => (props.checked) ? `
      background: #EF8200; border-radius: 20px;
      & :nth-child(2) {
        border: 2px solid #FFF;
        background-color: transparent !important;
      }` : null};
  `,
  ExamCheckBoxText: styled.div<{ checked: boolean }>`
    ${props => (props.checked) ? `
      color: #fff;
    ` : null}
  `,
  ExamNavigationContainer: styled.div`
    display: flex;
    justify-content: space-between;
    margin-top: 35px;
    padding-bottom: 5px;
  `,
  ExamNavigation: styled.div`
    display: flex;
    align-items: center;
    background: #838383;
    border-radius: 7px;
    box-shadow: 2px 2px 4px rgba(0, 0, 0, 0.25);
    cursor: pointer;
  `,
  ExamNavigationText: styled.p`
    background: #fff;
    font-weight: 500;
    font-size: 18px;
    line-height: 26px;
    color: #838383;
    padding: 1px 7px;
  `,
  LeftTriangle: styled.div`
    width: 0;
    border-style: solid;
    border-width: 7px 9px 7px 0;
    border-color: transparent #FFF transparent transparent;
    border-radius: 1px;
    margin: 3px 5px;
  `,
  RightTriangle: styled.div`
    width: 0;
    border-style: solid;
    border-width: 7px 0 7px 9px;
    border-color: transparent transparent transparent #FFF;
    border-radius: 1px;
    margin: 3px 5px;
  `,
  RemarkTooltipContainer: styled.div`
    position: absolute;
    top: -63px;
    left: -30px;
    z-index: 1;
  `,
  DownTriangle: styled.div`
    width: 0;
    border-style: solid;
    border-width: 9px 7px 0 7px;
    border-color: #9B9B9B transparent transparent transparent;
    position: absolute;
    left: 39px;
  `,
  RemarkTooltip: styled.div`
    width: 155px;
    background: #9B9B9B;
    border-radius: 5px;
    font-weight: 500;
    font-size: 12px;
    line-height: 17px;
    color: #FFFFFF;
    padding: 6px 17px 10px 19px;
  `,
  ExamTopic: styled.div`
    margin-bottom: 5px
  `,
  Img: styled.img`
    display: flex;
    margin-top: 20px;
    &:hover {
      cursor: pointer;
    }
  `,
  OptionImg: styled.img`
    display: flex;
    margin-top: 10px;
  `,
  Container: styled.label<{ checked: boolean }>`
    justify-content: flex-start;
    margin-bottom: 30px;
    font-weight: 500;
    font-size: 23px;
    line-height: 33px;
    padding: 8px 18px;
    & :nth-child(2) {
      min-width: 15px;
    }
    display: flex;
    justify-content: center;
    align-items: center;
    cursor: pointer;
    ${props => (props.checked) ? `
      background: #EF8200; border-radius: 20px;
      // & :nth-child(2) {
      //   border: 2px solid #FFF;
      //   min-width: 15px;
      // }
      & :nth-child(2)::before {
        background: #FFF !important;
      }
      & :nth-child(3) {
        color: #fff;
      }` : null};
    `,
  Radio: styled.input`
    &:disabled ~ *{
      opacity: 0.5;
    }
  `,
  Label: styled.div`
    font-size: 16px;
    line-height: 23px;
    color: #767676;
    margin-left: 10px;
  `,
  OuterCircle: styled.div<{ checked: boolean }>`
    border: 2px solid #767676;
    border-radius: 50%;
    width: 15px;
    height: 15px;
    display: flex;
    justify-content: center;
    align-items: center;
    position: relative;
    ${props => (props.checked) ? `
    &::before {
      content: '';
      width: 7px;
      height: 7px;
      border-radius: 50%;
      background: #767676;
    }
    `: null }
  `,
  ImgZoomIn: styled.img.attrs({ src: ZoomIn})<{ isMulti: boolean }>`
    position: absolute;
    bottom: 36px;
    right: 16px;
    opacity: 0.4;
    cursor: pointer;
    ${props => (props.isMulti) ? 'bottom: 40px; right: 53px;': null}
  `,
  OptionImgContainer: styled.div`
    position: relative;
  `,
  RadioWrapper: styled.div`
    position: relative;
  `,
  ExamQAContainer: styled.div`
  `,
  QnaTextArea: styled.textarea`
    padding: 10px;
    width: 96%;
    margin-left: 2%;
    margin-top: 10px;
    resize: none;
    min-height: 180px;
  `,
  QnaTitle: styled.p`
    margin-top: 20px;
    color: #666666;
  `,
  OverText: styled.p`
    font-size: 14px;
    margin-top: 10px;
    margin-left: 2%;
    color: #FE4747;
  `,
}

const ExamContent = (props: any): JSX.Element => {
  const examNowFocus = props.examNowFocus;
  const setExamNowFocus = props.setExamNowFocus;
  const handleExamRemark = props.handleExamRemark;
  const topicContents = props.topicContents;
  const isFinalQuestion = props.isFinalQuestion;
  const handleExamRender = props.handleExamRender;
  const handleChoosedAnswer = props.handleChoosedAnswer;
  const baseUrl = props.baseUrl;
  const examFocusType = props.examFocusType;
  const handleQnaAnswer = props.handleQnaAnswer;
  const handleFileUpload = props.handleFileUpload;

  const optionList = topicContents.options;
  const [isHovering, setIsHovering] = useState(false);
  const [showImgUp, setShowImgUp] = useState(false);
  const [showImgUpImg, setShowImgUpImg] = useState('');
  const [overText, setOverText] = useState(false);

  const changeShowImg = (visible: boolean) => {
    console.log(visible)
    setShowImgUp(visible);
  };

  const changeImg = (img: string | null) => {
    console.log(img)
    if (img) {
      setShowImgUpImg(img);
    } else {
      setShowImgUpImg('');
    }
  }

  const handleRemark = (title: string) => {
    handleExamRemark(title);
  };

  const handlePrev = () => {
    const newNavigation = parseInt(examNowFocus)-1;
    if (newNavigation != -1) {
      setExamNowFocus(newNavigation.toString());
      localStorage.setItem('examLastFocus', newNavigation.toString());
      handleExamRender(newNavigation);
    }
  }
  const handleNext = () => {
    const newNavigation = parseInt(examNowFocus)+1
    setExamNowFocus(newNavigation.toString());
    localStorage.setItem('examLastFocus', newNavigation.toString());
    handleExamRender(newNavigation);
  }

  const handleAnswer = (item: any) => {
    handleChoosedAnswer(topicContents.title, item);
  };

  const handleQaAnswer = (value: string) => {
    if (value.length < 5000) {
      handleQnaAnswer(topicContents.title, value);
      setOverText(false);
    } else {
      setOverText(true);
    }
  }

  const handleUpload = (file: any, base64Data: any) => {
    handleFileUpload(topicContents.title, file, base64Data);
  }

  const NavigationAction = () => {

    return (
      <S.ExamNavigationContainer>
        { examNowFocus === '0' ? <div></div> : <S.ExamNavigation onClick={handlePrev}><S.LeftTriangle/><S.ExamNavigationText>Prev</S.ExamNavigationText></S.ExamNavigation>}
        { isFinalQuestion ? null : <S.ExamNavigation onClick={handleNext}><S.ExamNavigationText>Next</S.ExamNavigationText><S.RightTriangle/></S.ExamNavigation>}
      </S.ExamNavigationContainer>
    )
  };

  const renderRemarkTooltip = () => {

    return (
      <S.RemarkTooltipContainer>
        <S.RemarkTooltip>
            Click here to Remark this question.
        </S.RemarkTooltip>
        <S.DownTriangle/>
      </S.RemarkTooltipContainer>
    )
  };

  const RadioAnswer = (props: any) => {
    const option = props.option;

    return (
      <S.RadioWrapper>
        <S.Container onClick={() => handleAnswer(option)} checked={topicContents.answers.indexOf(option) > -1}>
          <S.Radio type="radio" hidden/>
          <S.OuterCircle checked={topicContents.answers.indexOf(option) > -1}/>
          <S.Label>
            <Markdown.ExamMarkdown markdown={option} baseUrl={baseUrl} setShowImgUpImg={changeImg} setShowImgUp={changeShowImg} checked={topicContents.answers.indexOf(option) > -1}/>
          </S.Label>
        </S.Container>
      </S.RadioWrapper>
    )
  }

  const CheckBoxAnswer = (props: any) => {
    const option = props.option;

    return (
      <S.RadioWrapper>
        <S.ExamCheckBox onChange={() => handleAnswer(option)} value={option} checked={topicContents.answers.indexOf(option) > -1}>
          <S.ExamCheckBoxText checked={topicContents.answers.indexOf(option) > -1}>
            <Markdown.ExamMarkdown markdown={option} baseUrl={baseUrl} setShowImgUpImg={setShowImgUpImg} setShowImgUp={setShowImgUp} checked={topicContents.answers.indexOf(option) > -1}/>
          </S.ExamCheckBoxText>
        </S.ExamCheckBox>
      </S.RadioWrapper>
    )
  }

  return (
    <S.ExamContentContainer>
      <S.ExamContent>
        <S.ExamNumber>{parseInt(topicContents.title)+1}</S.ExamNumber>
        <S.ExamTopic>
          <Markdown.ExamMarkdown markdown={topicContents.contents} setShowImgUpImg={setShowImgUpImg} setShowImgUp={setShowImgUp} baseUrl={baseUrl}/>
        </S.ExamTopic>
        <S.Remark onClick={() => handleRemark(topicContents.title)} onMouseOver={() => { setIsHovering(true); }} onMouseOut={() => { setIsHovering(false); }} >
          { topicContents.isRemark ? <S.RemarkActiveIcon/> : <S.RemarkIcon/> }
          { isHovering ? renderRemarkTooltip() : null }
        </S.Remark>
      </S.ExamContent>
      { examFocusType === 'multiSelect' ? (
        <S.ExamoptionList>
          {optionList.map((item: string[], index: number) => {
            if (!topicContents.multiAnswer) {
              return (
                <RadioAnswer key={index} option={item} />
              )
            } else {
              return (
                <CheckBoxAnswer key={index} option={item} />
              )
            }
          })}
        </S.ExamoptionList>
      ) : (
        <S.ExamQAContainer>
          <S.QnaTitle>Your Answer:</S.QnaTitle>
          <S.QnaTextArea value={topicContents.answers} onChange={(e) => { handleQaAnswer(e.target.value) }}/>
          { overText ? <S.OverText><FormattedMessage id="K042" /></S.OverText> : null}
          <FileUpload uploadFile={topicContents.file} handleUpload={handleUpload}/>
        </S.ExamQAContainer>
      )}
      <NavigationAction/>
      <ImgPopUp img={showImgUpImg} showImgUp={showImgUp} setShowImgUp={setShowImgUp} />
    </S.ExamContentContainer>
  )
};

export default ExamContent;
